import React, { ReactElement, useEffect } from 'react'

import BannerMainImageSection from 'components/bannerMainImageSection'
import BannerBrandImageSection from 'components/bannerBrandImageSection'
import ContactUsDialog from 'components/dialog/contactUsDialog'
import { useSelector, useDispatch } from 'react-redux'
import withLocation from 'components/withLocation'
import { connect } from 'react-redux'
import Layout from 'layout'
import ContentSection from './contentSection'
import {
  fireViewStartCustomEvent,
  fireViewEndCustomEvent,
  checkConsultant,
} from 'helpers'
import { useHistory } from 'react-router-dom'
import { fetchIndividualEstimate } from 'actions/individualEstimateActions'
import { fetchIndividualEstimate as fetchIndividualEstimateConsultant } from 'actions/consultantIndividualEstimateActions'
import { httpVerbConstants } from 'constants/actionTypes'
import * as E from './homeElements'
import useNextSteps from 'helpers/usenextSteps'
import NextStepContent from './nextStepContent'
import OpportunityLostStage from './stages/OpportunityLostStage'
import EstimateToBeReviewedStage from './stages/EstimateToBeReviewedStage'
import EstimateAcceptedStage from './stages/EstimateAcceptedStage'
import ProposalAcceptedWithoutNextStepsStage from './stages/ProposalAcceptedWithoutNextStepsStage'
import ProposalToBeReviewedStage from './stages/ProposalToBeReviewedStage'
import { ITheme } from 'utils/type'
import { INextStepProps } from './homeTypes'
import { fetchFinAppStatus } from 'actions/finAppStatusActions'
import { fetchFinAppStatusConsultant } from 'actions/consultantFinAppStatusActions'
import { FinAppStatusValue, NextStepValue } from 'utils/type'
import SettlementStage from './stages/SettlementStage'
import { ISettlementRecipient } from '../ISettlementInputProps'

interface IInputProps {
  accessToken: any
  isAuthenticated: boolean
  opportunityId: string
  consultantFirstName: string
  userFirstName: string
  proposalEstimateId: string
  selectedEstimateId: string
  isGov: boolean
  applicationRole: { isConsultant: boolean }
  nextSteps: INextStepProps
  theme: ITheme
}
interface IStateApplicationRole {
  applicationRoles: any
}
interface IStateOpportunity {
  opportunity: any
}
interface IStateProposalEstimate {
  individualEstimate: { estimate: any }
}
interface IStateEmailProposal {
  email: { isEmailProposalView: boolean }
}
interface IStateUser {
  user: { hasSpartaVehicle: boolean; isAtSettlement: boolean }
}

const Home = ({
  accessToken,
  isAuthenticated,
  opportunityId,
  consultantFirstName,
  userFirstName,
  proposalEstimateId,
  selectedEstimateId,
  isGov,
  applicationRole,
  nextSteps,
  theme,
}: IInputProps) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const isConsultant = applicationRole.isConsultant
  const getNextSteps = useNextSteps()
  const { proposalCompleted, nextStepMethod } = getNextSteps
  let headers = { accessToken: accessToken }
  const userEvents = () => {
    if (
      proposalEstimateId &&
      proposalEstimateId !== '00000000-0000-0000-0000-000000000000' &&
      proposalEstimateId !== selectedEstimateId
    ) {
      // Make sure this call does not update the analytics data
      dispatch(
        fetchIndividualEstimate(opportunityId, proposalEstimateId, true, false)
      )
    }

    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'oly:mylease:home' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'oly:mylease:home' },
        },
      })
    }
  }

  const consultantEvents = () => {
    if (
      proposalEstimateId &&
      proposalEstimateId !== '00000000-0000-0000-0000-000000000000' &&
      proposalEstimateId !== selectedEstimateId
    ) {
      dispatch(
        fetchIndividualEstimateConsultant(
          opportunityId,
          proposalEstimateId,
          headers,
          httpVerbConstants.HTTP_GET
        )
      )
    }

    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'oly:mylease:consultant:home' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'oly:mylease:consultant:home' },
        },
      })
    }
  }
  useEffect(() => {
    proposalCompleted && nextStepMethod()
  }, [proposalCompleted])

  useEffect(() => {
    if (isAuthenticated && opportunityId) {
      checkConsultant() ? consultantEvents() : userEvents()
    }
  }, [isAuthenticated, opportunityId])

  const firstName = userFirstName
  const applicationRoles = useSelector(
    (state: IStateApplicationRole) => state.applicationRoles
  )
  const opportunity = useSelector(
    (state: IStateOpportunity) => state.opportunity
  )

  let financeApplicationNumber =
    opportunity && opportunity.financeapplicationnumber

  useEffect(() => {
    if (financeApplicationNumber)
      checkConsultant()
        ? dispatch(
            fetchFinAppStatusConsultant(
              financeApplicationNumber,
              headers,
              httpVerbConstants.HTTP_GET
            )
          )
        : dispatch(fetchFinAppStatus(opportunityId,financeApplicationNumber))
  }, [financeApplicationNumber])

  let finAppStatus = useSelector((state: any) => state.finAppStatus)
  const reviewProposalLink = `${
    isConsultant ? '/consultant' : ''
  }/proposal/${proposalEstimateId}/review`
  let viewAcceptedProposal = `${
    isConsultant ? '/consultant' : ''
  }/proposal/${proposalEstimateId}/review/pdfview`
  let estimateLink = `${isConsultant ? '/consultant' : ''}/estimates`
  let settlementLink = `${isConsultant ? '/consultant' : ''}/settlements`
  const notificationElement = document.getElementById('notification')
  if (notificationElement !== undefined && notificationElement !== null) {
    let d = document.getElementById('notification')
    if (d) d.style.display = 'none'
  }

  let proposalEstimate = useSelector((state: IStateProposalEstimate) =>
    state.individualEstimate && state.individualEstimate.estimate
      ? state.individualEstimate.estimate
      : null
  )

  var isEmailProposalView = useSelector(
    (state: IStateEmailProposal) => state.email.isEmailProposalView
  )
  if (proposalEstimateId && isEmailProposalView && opportunityId) {
    history.push(viewAcceptedProposal)
  }

  var isSparta = useSelector((state: IStateUser) => state.user.hasSpartaVehicle)

  const isRe_lease =
    opportunity &&
    opportunity.channel &&
    opportunity.channel.toLowerCase() == 'release'

  let registrationNumber = ''
  let currentOutOfPocket = 0
  let leaseEndDate = ''
  if (isRe_lease) {
    registrationNumber = opportunity.registrationNumber
    currentOutOfPocket = opportunity.currentNLOutOfPocketCostPerPay
    leaseEndDate = opportunity.leaseEndDate
  }

  let isAtReviewEstimates =
    applicationRoles &&
    !applicationRoles.hasProposal &&
    !applicationRoles.hasSubmittedEstimate &&
    opportunity &&
    opportunity.state &&
    opportunity.state !== 'Lost'

  let isAtEstimateProceed =
    applicationRoles &&
    !applicationRoles.hasProposal &&
    applicationRoles.hasSubmittedEstimate &&
    !applicationRoles.hasProposalAccepted &&
    opportunity &&
    opportunity.state &&
    opportunity.state !== 'Lost'

  let isAtReviewProposal =
    applicationRoles &&
    applicationRoles.hasProposal &&
    applicationRoles.hasSubmittedEstimate &&
    !applicationRoles.hasProposalAccepted &&
    opportunity &&
    opportunity.state &&
    opportunity.state !== 'Lost'

  let isAtProposalAccepted =
    applicationRoles &&
    applicationRoles.hasProposal &&
    applicationRoles.hasSubmittedEstimate &&
    applicationRoles.hasProposalAccepted &&
    opportunity &&
    opportunity.state &&
    opportunity.state !== 'Lost'

  let digitalSettlement = useSelector(
    (state: IStateOpportunity) =>
      state.opportunity.settlement &&
      state.opportunity.settlement.recipients &&
      state.opportunity.settlement.recipients.length > 0
  )

  let isAtSettlement =
    useSelector(
      (state: IStateOpportunity) =>
        state.opportunity.settlement &&
        state.opportunity.settlement.recipients &&
        state.opportunity.settlement.recipients.filter(
          (r: ISettlementRecipient) => !r.hasSigned
        ).length > 0
    ) && isAtProposalAccepted

  let currentViewEstimateBannerContent: ReactElement =<></>
  
  if (isAtReviewEstimates) {//ignore Release & Sparta for Oly
    let line1: ReactElement = <span>The estimate for your Oly novated lease is ready! Check out your options now or keep reading to learn what the next steps are. Need a quick reminder on what a novated lease is and how it could get you behind the wheel of a new car for less $$? Oly's got you...</span>
    let line2: ReactElement=<></>

    if (
      (finAppStatus.status == FinAppStatusValue.NOTSTARTED ||
        finAppStatus.status == FinAppStatusValue.STARTED) &&
      finAppStatus.url != '' &&
      finAppStatus.url != null
    )
      line2 = <span>{' '}Please click on 'Start finance application' to complete your Finance application for {consultantFirstName} to get quick financier approval for you.</span>

      currentViewEstimateBannerContent=<div>{line1}{line2}</div>
    }
  const estimateToBeReviewedStageProps = {
    firstName: userFirstName,
    bannerContent: currentViewEstimateBannerContent,
    estimateLink: estimateLink,
    finAppUrl:
      finAppStatus.status == FinAppStatusValue.NOTSTARTED ||
      finAppStatus.status == FinAppStatusValue.STARTED
        ? finAppStatus.url
        : '',
  }

  const opportunityLostStageProps = {
    firstName: userFirstName,
  }

  const estimateAcceptedStageProps = {
    firstName: userFirstName,
    consultantFirstName: consultantFirstName,
    isConsultant: isConsultant,
    finAppStatus: finAppStatus,
  }

  const proposalToBeReviewedStageProps = {
    firstName: firstName,
    consultantFirstName: consultantFirstName,
    vehicleDescription:
      proposalEstimate && proposalEstimate.vehicleDescription
        ? proposalEstimate.vehicleDescription
        : null,
    isSparta: isSparta,
    estimateLink: estimateLink,
    reviewProposalLink: reviewProposalLink,
  }

  const proposalAcceptedWithoutNextStepsStageProps = {
    firstName: firstName,
    settlementLink: settlementLink,
    proposalLink: reviewProposalLink,
    digitalSettlement: digitalSettlement,
  }

  const nextStepsContentData = {
    nextSteps: nextSteps,
    proposalEstimate: proposalEstimate,
    firstName: userFirstName,
    consultantFirstName: consultantFirstName,
    viewAcceptedProposal: viewAcceptedProposal,
  }

  const contentSectionData = {
    isGov: isGov,
    consultantFirstName: consultantFirstName,
    applicationRole: applicationRoles.CUSTOMER,
    isrelease: isRe_lease,
    registrationNumber: registrationNumber,
    currentNLOutOfPocket: currentOutOfPocket,
    leaseEndDate: leaseEndDate,
    theme: theme,
  }

  const settlementStageProps = {
    firstName: firstName,
    vehicleDescription:
      proposalEstimate && proposalEstimate.vehicleDescription
        ? proposalEstimate.vehicleDescription
        : null,
    proposalLink: reviewProposalLink,
    settlementLink: settlementLink,
  }

  return (
    <Layout>
      <E.HomeContainer id="page" theme={theme}>
        {opportunity && opportunity.state && opportunity.state === 'Lost' && (
          <OpportunityLostStage {...opportunityLostStageProps} />
        )}

        {isAtReviewEstimates && (
          <EstimateToBeReviewedStage {...estimateToBeReviewedStageProps} />
        )}

        {isAtEstimateProceed && (
          <EstimateAcceptedStage {...estimateAcceptedStageProps} />
        )}

        {isAtProposalAccepted &&
          opportunity.state === 'Won' &&
          !isAtSettlement && (
            <ProposalAcceptedWithoutNextStepsStage
              {...proposalAcceptedWithoutNextStepsStageProps}
            />
          )}

        {isAtProposalAccepted &&
          opportunity.state !== 'Won' &&
          !isAtSettlement && (
            <>
              <BannerMainImageSection>
                <E.WhiteHeading>OLY NOVATED LEASE</E.WhiteHeading>
                <h1>Congratulations {firstName}!</h1>
              </BannerMainImageSection>

              <BannerBrandImageSection id="maincontent">
                <NextStepContent {...nextStepsContentData} />
              </BannerBrandImageSection>
            </>
          )}

        {isAtReviewProposal && (
          <ProposalToBeReviewedStage {...proposalToBeReviewedStageProps} />
        )}

        {isAtSettlement && (
          <>
            <SettlementStage
              firstName={settlementStageProps.firstName}
              vehicleDescription={settlementStageProps.vehicleDescription}
              settlementLink={settlementStageProps.settlementLink}
              proposalLink={settlementStageProps.proposalLink}
            />
          </>
        )}

        <ContentSection {...contentSectionData} />
      </E.HomeContainer>
    </Layout>
  )
}

function mapStateToProps(
  state: {
    authentication: any
    auth: { accessToken: any }
    consultant: { firstName: string }
    user: { firstName: string; isGov: boolean }
    proposal: { proposal: { quoteId: string } }
    individualEstimate: { selectedEstimateId: string }
    applicationRoles: any
    nextSteps: INextStepProps
  },
  ownProps: any
) {
  const { isAuthenticated, opportunityId } = state.authentication
  const { firstName: consultantFirstName } = state.consultant
  const { firstName: userFirstName } = state.user
  const accessToken = state.auth.accessToken
  const isGov = state.user.isGov
  const proposalEstimateId =
    state.proposal && state.proposal.proposal && state.proposal.proposal.quoteId
      ? state.proposal.proposal.quoteId
      : null
  const selectedEstimateId =
    state.individualEstimate && state.individualEstimate.selectedEstimateId
  const applicationRole = state.applicationRoles
  const nextSteps = state.nextSteps
  return {
    accessToken,
    isAuthenticated,
    opportunityId,
    consultantFirstName,
    userFirstName,
    proposalEstimateId,
    selectedEstimateId,
    isGov,
    applicationRole,
    nextSteps,
  }
}
export default connect(mapStateToProps)(withLocation(Home))
